export class ForsyningWebIndstilling {
    public siteUrl?: string;
    public nodeId?: number;
    public driftsstatusUrl?: string;
}
